
export default [
    {
        path: '/manage/repairAudit',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '修护审核',
            keepAlive: false
        }
    },   
];
  